import {
  CreateChannelOptions,
  Importance,
  Visibility,
} from '@capacitor-firebase/messaging';

export const ANDROID_CHANNELS: CreateChannelOptions[] = [
  {
    id: 'myoncare_channel',
    name: 'myoncare',
    description: 'default channel',
    importance: Importance.High,
    sound: 'myoncare.mp3',
    vibration: true,
    visibility: Visibility.Public,
  },
  {
    id: 'myoncare_video_channel',
    name: 'myoncare',
    description: 'video calls channel',
    importance: Importance.High,
    sound: 'videocall.mp3',
    vibration: true,
    visibility: Visibility.Public,
  },
];
